import { UserContext } from './UserContext';
import { Error } from '@quickplay/foundation';

export interface CastMessage {
  messageName: MessageName;
  messageType: MessageType;
  messageOrigin: MessageOrigin;
  message: UserContext | Error | any;
}

export enum MessageOrigin {
  SENDER = 'sender',
  RECEIVER = 'receiver',
}

export enum MessageType {
  ERROR = 'error',
  INFO = 'info',
  SUCCESS = 'success',
}

export enum MessageName {
  USER_CONTEXT = 'userContext',
  PLAYBACK_AUTHORISATION = 'playbackAuthorisation',
  DEVICE_REGISTRATION = 'deviceRegistration',
  CUSTOM = 'custom',
  SELECT_TRACK = 'selectTrack',
  FALLBACK_NOTIFICATION = 'fallbackNotification',
}
